<template>
  <div class="index">
    <my-header></my-header>
    <div class="container">
      <div class="scroll">
        <div class="left">
          <div class="outdoor">
            <out-weather></out-weather>
          </div>
          <div class="indoor">
            <sensor></sensor>
          </div>
        </div>
        <div class="right">
          <div class="subject">
            <subject></subject>
          </div>
          <div class="notify">
            <div><img src="../assets/images/home/gg.png" style="height: 25px;"/></div>
            <div><span v-text="lastNotify"></span></div>
            <div>
              <router-link to="/notify">{{$config.staticConfig.isNeed ?  '' : '查看'}}更多</router-link>
            </div>
          </div>
          <div class="warp" :class="!collectionScene.length && 'round-bg'">
            <div class="scene" v-if="collectionScene.length">
              <scene v-for="(s,i) in collectionScene" @change="change" :scene="s" :key="`scene_${i}`"></scene>
            </div>
            <template v-else>
              <div class="none">
                <!--<img src="../assets/images/device/sc.png" style="height: 25px"/>-->
                <span>暂无收藏场景</span>
              </div>
            </template>
          </div>
          <div class="warp-device" :class="!batchDevice.length && 'round-bg'">
            <div class="device" v-if="batchDevice.length">
              <device v-for="(d,i) in batchDevice" :device="d" @change="change" :key="`batch_${i}`"></device>
            </div>
            <template v-else>
              <div class="none">
                暂无智能设备
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <my-tool-box></my-tool-box>
  </div>
</template>
<script>
import BScroll from 'better-scroll'
import MyHeader from '../components/Header'
import MyToolBox from '../components/ToolBox'
import OutWeather from '../components/OutWeather'
import Subject from '../components/Subject'
import Scene from '../components/SceneSimple'
import Device from '../components/DeviceSimple'
import Sensor from '../components/Sensor'
import { mapState } from 'vuex'
import basic from '../model/zone'
import comm from '../assets/lib/comm'

export default {
  name: 'Index',
  components: {
    MyHeader,
    MyToolBox,
    OutWeather,
    Subject,
    Scene,
    Sensor,
    Device
  },
  created () {
    // 请求数据，如果不存在的话
    // if (!this.zone) {
    //   basic.getBasicInfo()
    // }
  },
  data () {
    return {
      types: {
        all: { name: '全部', state: 0, list: [] },
        light: { name: '灯具', state: 0, list: [] },
        aircon: { name: '空调', state: 0, list: [] },
        curtain: { name: '窗帘', state: 0, list: [] },
        airpure: { name: '新风', state: 0, list: [] },
        fan: { name: '风扇', state: 0, list: [] },
        switch: { name: '智能插座', state: 0, list: [] },
        airswitch: { name: '智慧空开', state: 0, list: [] },
        lora_aircon: { name: '空调', state: 0, list: [] },
        // 屏蔽仪占用了colorbar位置
        colorbar: { name: '屏蔽仪', state: 0, list: [] }
      }
    }
  },
  computed: {
    ...mapState(['devices', 'scenes', 'subject', 'notify', 'sensor', 'zone', 'collection', 'lights', 'extDevices', 'config', 'otherExtDevices']),
    lastNotify () {
      // 对notify进行排序，并获取最新的一条，如果没有那么显示暂无最新通知
      return this.notify.length ? comm.htmlFormat(this.notify[this.notify.length - 1].html) : '暂无最新通知'
    },
    collectionScene () {
      return this.collection.scenes.map(cs => {
        const s = this.scenes.filter(sc => sc.id === cs.id)
        if (s.length) {
          return s[0]
        } else {
          return 0
        }
      }).filter(s => s !== 0)
    },
    batchDevice () {
      // 根据用户现有设备，进行生成，格式要求能达到控制即可，主要参数如下 1、type 2、tp 3、名称 4、状态 (默认全部为关)
      // 增加新需求---设备的状态同步2019/09/16
      const types = this.dealState()
      const devices = []
      this.lights.length && devices.push({ type: 'light', tp: [37, 39], name: '灯具', state: types['light'].state })
      this.extDevices.length && this.extDevices.forEach(ext => {
        if (types[ext.devicetype.key] && !devices.filter(d => d.type === ext.devicetype.key).length) {
          devices.push({
            type: ext.devicetype.key,
            tp: ext.devicetype.type,
            name: types[ext.devicetype.key].name,
            state: types[ext.devicetype.key].state
          })
        }
      })
      this.otherExtDevices.length && this.otherExtDevices.forEach(otherExt => {
        if (types[otherExt.key] && !devices.filter(d => d.type === otherExt.key).length) {
          devices.push({
            type: otherExt.key,
            tp: otherExt.type,
            name: types[otherExt.key].name,
            state: types[otherExt.key].state
          })
        }
      })
      // 外部其他设备
      devices.length && devices.unshift({ type: 'all', tp: 0, name: '全部设备', state: types['all'].state })
      return devices
    }
  },
  mounted () {
    // this.$nextTick(() => {
    //   if (!this.scroll) {
    //     this.scroll = new BScroll('.warp', {
    //       scrollX: true,
    //       click: false,
    //       eventPassthrough: 'vertical'
    //     })
    //     this.scroll1 = new BScroll('.warp-device', {
    //       scrollX: true,
    //       click: false,
    //       eventPassthrough: 'vertical'
    //     })
    //   }
    // })
  },
  methods: {
    // change (device, state) {
    //   // if (device.type === 'all') {
    //   //   for (const key in this.types) {
    //   //     if (key === 'all' || (this.config && this.config.filter(c => c.value).map(c => c.key).includes(key))) {
    //   //       this.types[key].state = (state && true) || false
    //   //     }
    //   //   }
    //   // } else {
    //   //   this.types[device.type].state = (state && true) || false
    //   // }
    // },
    // 组件滑动
    change (data) {
      if (data === 'sceneHtml' && !this.scroll) {
        this.scroll = new BScroll('.warp', {
          scrollX: true,
          click: false,
          eventPassthrough: 'vertical'
        })
      }
      if (data === 'deviceHtml' && !this.scroll1) {
        this.scroll1 = new BScroll('.warp-device', {
          scrollX: true,
          click: false,
          eventPassthrough: 'vertical'
        })
      }
    },
    // 处理所有总结设备的状态
    dealState () {
      let rule = ['all', 'light', 'aircon', 'curtain', 'airpure', 'fan', 'switch', 'airswitch', 'lora_aircon', 'colorbar']
      let limit = ['all']
      if (this.lights.length) {
        limit.push('light')
      }
      // 电灯状态
      this.types['light'].state = ~~(this.lights.length && this.lights.every(item => item.state === 1))
      for (const key in this.types) {
        this.types[key]['list'] = []
      }
      this.extDevices.length && this.extDevices.forEach(ext => {
        limit.push(ext.devicetype.key)
        let obj = this.types[ext.devicetype.key]
        if (obj && !obj.list.find(item => item.name === ext.name)) {
          // 排除射灯在switch
          if (ext.devicetype.key === 'switch' && ext.name.indexOf('射灯') > -1) {
            return
          }
          obj.list.push(ext)
        }
      })
      // 其他外部设备
      this.otherExtDevices.length && this.otherExtDevices.forEach(ext => {
        limit.push(ext.key)
        let obj = this.types[ext.key]
        if (obj && !obj.list.find(item => item.name === ext.name)) {
          obj.list.push(ext)
        }
      })
      // 去重
      limit = Array.from(new Set([...limit]))
      // 取交集
      let a = new Set(rule)
      let b = new Set(limit)
      let current = [...new Set([...a].filter(n => b.has(n)))]
      // 外部设备处理
      let list = ['aircon', 'curtain', 'airpure', 'fan', 'switch', 'airswitch', 'lora_aircon', 'colorbar']
      list.forEach(item => {
        this.types[item].state = ~~(this.types[item].list.length && this.types[item].list.every(items => items.state && items.state.state && items.state.state !== 2))
      })
      // 全部的处理
      let all = []
      let remaining = {}
      current.forEach(item => {
        remaining[item] = this.types[item]
      })
      // 在限制内
      for (const key in remaining) {
        if (!this.config || this.config.filter(c => c.value).map(c => c.key).includes(key)) {
          if (key !== 'all') {
            all.push(remaining[key].state)
          }
        }
      }
      remaining['all'].state = ~~all.every(item => item)
      return JSON.parse(JSON.stringify(remaining))
    }
  }
}
</script>
<style lang="less">
@import "../assets/less/base";

.index {
  display: flex;
  height: 100%;
  position: relative;
  flex-direction: column;
  .container {
    flex: 1;
    margin: 45px 0px;
    overflow-y: auto;
    .scroll {
      display: flex;
      min-height: 100%;
      padding: 20px;
      > .left {
        flex: 0.31;
        width: 0;
        min-height: 615px;
        min-width: 230px;
        max-width: 230px;
        display: flex;
        flex-direction: column;
        > .outdoor {
          height: 90px;
          background: linear-gradient(-32deg, rgba(172, 227, 255, 1), rgba(78, 189, 240, 1));
          border-radius: 6px;
        }
        > .indoor {
          margin-top: 20px;
          flex: 1;
          max-height: 100%;
          height: 505px;
          min-height: 505px;
        }
      }
      > .right {
        display: flex;
        flex-direction: column;
        margin-left: 20px;
        flex: 1;
        max-width: 100%;
        width: 0;
        min-width: 0;
        .notify {
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 3px 17px 2px rgba(219, 219, 219, 0.3);
          border-radius: 4px;
          padding: 16px 20px;
          margin-top: 20px;
          display: flex;
          justify-content: space-between;
          > div:first-child {
            height: 24px;
          }
          > div:nth-child(2) {
            margin-left: 16px;
            font-size: 14px;
            .auto-hide;
            flex: 1;
            font-weight: 400;
            color: rgba(191, 191, 191, 1);
            display: flex;
            align-items: center;
            width: 100px
          }
          > div:last-child {
            width: 80px;
            .text-right;
          }
        }
        .warp {
          overflow: hidden;
          position: relative;
          max-height: 100px;
          min-height: 84px;
          margin-top: 20px;
          .scene {
            position: absolute;
            /*min-width: 100%;*/
            display: flex;
            max-height: 100px;
            min-height: 84px;
            white-space: nowrap;
            > div {
              margin-right: 20px;
            }
            > div:last-child {
              margin-right: 0px;
            }
          }
        }
        .warp-device {
          overflow: hidden;
          position: relative;
          flex: 1;
          max-height: 200px;
          margin-top: 20px;
          .device {
            position: absolute;
            /*min-width: 100%;*/
            display: flex;
            height: 100%;
            white-space: nowrap;
            > div {
              margin-right: 20px;
            }
            > div:last-child {
              margin-right: 0px;
            }
          }
        }
        .round-bg {
          background-color: white;
          border-radius: 4px;
        }
      }
    }
  }
}
</style>
